import BookProgressControls from './BookProgressControls';

export default BookProgressControls;
